// extracted by mini-css-extract-plugin
module.exports = {"iframe":"DrawerIframe_iframe__3lAlp","loader":"DrawerIframe_loader__21kdj"};